import React from 'react';

export const FeatureSection = ({ payload }) => {
    return (
        <section className="feature-section">
            {
                payload?.map((item, index) => (
                    <div key={index} className={`feature-container ${index === 5 && "feature-container-large"}`}>
                        <div className="feature-container-item">
                            <div>{item}</div>
                        </div>
                    </div>
                ))
            }
        </section>
    )
}